#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment flexibleImage on flexibleSections_image_BlockType {
    image {
        ... DefaultImageAsset
    }
    caption
    alt: plaintext
}
